// Chat app-setting keys read outside chat-common. CHAT_SPAM_SENDER_LIST is retired — the spam
// sender list is the `SpamSender` collection — and only migrations and the db-restore address faking read the key.
export enum ChatAppSettingKeyEnum {
  CHAT_SPAM_SENDER_LIST = 'CHAT_SPAM_SENDER_LIST',
}
